module.exports = __webpack_public_path__ + "d95f5ae6bf122a7b61ec8dcd3001d3f8.pdf";